export default {
    created: "Campania trimisa WhatsApp a fost creata cu succes.",
    updated: "Campania trimisa WhatsApp a fost actualizata cu succes.",
    deleted: "Campania trimisa WhatsApp a fost stearsa cu succes.",
    restored: "Campania trimisa WhatsApp a fost restaurata cu succes.",
    retried: "Mesajele esuate pentru aceasta campanie au fost retrimise.",
}
